<template>
  <div>
    <div>
      <div style="visibility:hidden;height:0;width:0">
        <object id="Test" classid="clsid:B5E75DBF-2429-4A5F-924A-2E14B884405B">
          <param name="_Version" value="65536">
          <param name="_ExtentX" value="2646">
          <param name="_ExtentY" value="1323">
          <param name="_StockProps" value="0">
        </object>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    mounted() {
    },
    beforeDestroy() {
    },
    methods: {},
    created() {
      this.$router.onReady(() => {

      })
    }
  }
</script>

<style lang="less">
</style>